const state = {
  demoDisableKey: false,
};

const mutations = {};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  demoDisableKey: (state) => {
    return state.demoDisableKey;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
